import React, {useState} from 'react';
import axios from 'axios';
import { useNavigate } from "react-router-dom";
import { Formik, Form } from "formik"
import useSafeState from '../../../../../../useSafeState'; 
import Typography from '@mui/material/Typography';
import TextInput from '../../../../../../components/Forms/TextInput';
import ButtonForm from "../../../../../../components/Button/ButtonForm";
import Alert from "@mui/material/Alert";
import Button from '@mui/material/Button';
import { FILTER_DRUGS } from "../../../../../../constants";
import ButtonGeneGrey from "../../../../../../components/Button/ButtonGeneGrey";
import Grid from '@mui/material/Grid';
import PgxAccordion from '../../../../../../components/TextComps/PgxAccordion';
import ButtonGeneTrans from '../../../../../../components/Button/ButtonGeneTrans';
import Autocomplete from '@mui/material/Autocomplete';




const druglist = [
  'Ascorbic acid (vitamin C), combinations', 'Ascorbic acid (vitamin C), plain', 'abacavir', 'abrocitinib', 'acenocoumarol', 'acetaminophen / caffeine / dihydrocodeine', 'allopurinol', 'amikacin', 'amitriptyline', 'amoxapine', 'amphetamine', 'aripiprazole', 'aripiprazole lauroxil', 'articaine / epinephrine', 'atazanavir', 'atomoxetine', 'atorvastatin', 'avatrombopag', 'azathioprine', 'belinostat', 'belzutifan', 'brexpiprazole', 'brivaracetam', 'bupivacaine',
 'capecitabine', 'carbamazepine', 'carisoprodol', 'carvedilol', 'celecoxib', 'cevimeline', 'chloroquine', 'chlorpropamide', 'citalopram', 'clobazam', 'clomipramine', 'clopidogrel', 'clozapine', 'codeine', 'dabrafenib', 'dapsone', 'darifenacin', 'desflurane', 'desipramine', 'deutetrabenazine', 'dexlansoprazole', 'dextromethorphan / quinidine', 'dextromethorphan hydrobromide / bupropion hydrochloride', 'diazepam', 'dibekacin', 'dolutegravir', 'donepezil', 'doxepin', 'dronabinol', 'efavirenz', 'elagolix', 'eliglustat', 'enflurane', 'erdafitinib', 'escitalopram', 'esomeprazole',
'fesoterodine', 'flecainide', 'flibanserin', 'flucloxacillin', 'flucytosine', 'fluorouracil', 'fluoxetine', 'flurbiprofen', 'flutamide', 'fluvastatin', 'fluvoxamine', 'fosphenytoin', 'galantamine', 'gefitinib', 'gentamicin', 'glimepiride', 'glipizide', 'glyburide', 'haloperidol', 'halothane', 'hydrocodone', 'hydroxychloroquine', 'ibuprofen', 'iloperidone', 'imipramine', 'irinotecan', 'isoflurane', 'ivacaftor', 
'kanamycin', 'lamotrigine', 'lansoprazole', 'lesinurad', 'lidocaine / prilocaine', 'lidocaine and tetracaine', 'lofexidine', 'lornoxicam', 'lovastatin', 'mavacamten', 'meclizine', 'meloxicam', 'mepivacaine', 'mercaptopurine', 'methoxyflurane', 'methylene blue', 'metoclopramide', 'metoprolol', 'mirabegron', 'moviprep',
'nalidixic acid', 'nateglinide', 'nebivolol', 'neomycin', 'netilmicin', 'nilotinib', 'nitrofurantoin', 'nortriptyline', 'oliceridine', 'omeprazole', 'ondansetron', 'oxcarbazepine', 'oxymetazoline and tetracaine', 
 'pantoprazole', 'paromomycin', 'paroxetine', 'pazopanib', 'peginterferon alfa-2a', 'peginterferon alfa-2b', 'pegloticase', 'perphenazine', 'phenprocoumon', 'phenytoin', 'pimozide', 'piroxicam', 'pitavastatin', 'pitolisant', 'plazomicin', 'pravastatin', 'primaquine', 'propafenone', 'propranolol', 'protriptyline', 'quetiapine', 'rabeprazole', 'raltegravir', 'rasburicase', 'ribavirin', 'ribostamycin', 'risperidone', 'ropivacaine', 'rosuvastatin', 'sacituzumab govitecan', 'sertraline', 'sevoflurane', 'simvastatin', 'siponimod', 'sodium ascorbate', 'sodium nitrite', 'streptomycin', 'succinylcholine', 'sulfasalazine', 
 'tacrolimus', 'tafenoquine', 'tamoxifen', 'tamsulosin', 'tegafur', 'tenoxicam', 'tetrabenazine', 'thioguanine', 'thioridazine', 'tobramycin', 'tolazamide', 'tolbutamide', 'tolterodine', 'toluidine blue', 'tramadol', 'trimipramine', 'tropisetron', 'valbenazine', 'venlafaxine', 'viloxazine', 'voriconazole', 'vortioxetine', 'warfarin', 'zuclopenthixol'
]

export function GetDrugSearchCard() {


  const navigate = useNavigate();
  
  const [value, setValue] = useSafeState({});
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();
    
       
  const handleSubmit = (values) => {

    setLoading(true)
    axios.get(`${FILTER_DRUGS}/?drug=${values.drug}`)
    .then((res) => {
      setData(res.data);
        setLoading(false)
        setValue({ key: 'value' }); // NO MEMORY LEAK
    })
    .catch(function (error) {
      //throw new Error(error)
      setError(error.toJSON());
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        //console.log(error.response.data, error.response.status);
        
      } else if (error.request) {
        // The request was made but no response was received
        // `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
        //console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        //console.log('Error', error.message);
      }
      //console.log(error.config);
      console.log("Error")
    })
  }
  
  

return (
<>

 <Grid container sx={{ width: '100%'}}>
    <Grid size={{xs:12}} sx={{mt:0, mb:1, display:'flex', justifyContent:'center', alignItems:'center'}}>    
      
      <Formik
        enableReinitialize
        initialValues={{ drug: '' }}
        // validationSchema={validationRules} 
        onSubmit={(values, { setSubmitting }) => { 
            // same shape as initial values
            handleSubmit(values);
            setSubmitting(false);
          }}
      >
      {({ values, setFieldValue, }) => (
     <Form>

     <Autocomplete
        disablePortal
        options={druglist}
        value ={values.drug}
        onChange={(e, value) => setFieldValue('drug', value)}
        renderInput={(params) =>  <TextInput {...params} name="drug" focused type="text" placeholder="select drug" bgcolor="background.default" />}
      />
      
      <ButtonForm name={ 'Submit' }  disabled={Formik.isSubmitting} />        

    </Form>
    )}

  </Formik>
  </Grid>
</Grid>

{error  ? (
            <Alert severity="error" sx={{mt:2}}>
                <Typography variant="body2"  sx={{fontWeight: '500'}}> {error.message} </Typography>
                <Button variant="contained" onClick={() => { navigate("/", { replace: true }) }} sx={{mt:1, bgcolor: 'tertiary.dark', color:'common.white'}}> Try again </Button>
            </Alert>
            ) : (null)}




<Grid size={12} sx={{mt:4}}>

{ loading && <span> Please wait ... fetching data </span>}

{data  ? (
        data.map((i, index) => 
              
             <PgxAccordion key={index} 
             
                               drugname = {i.drug}
                               source = {<ButtonGeneTrans  name={i.source} />}
             
                               g="PGx Gene:"
                               gt="Genotype:"
                               ph="Phenotype:"
             
                               genename={<ButtonGeneGrey  name={i.gene} />}
                               genotype={i.genotype}
                               phenotype={i.phenotype}
             
                               gl="Guideline:"
                               gl_name={i.guideline}
                               pop="Population:"
                               pop_name={i.population}
             
                               imp="Implications:"
                               imp_name={i.implications}
                               rec="Reommendation:"
                               rec_name={i.drugRecommendaiton}
                               clas="Classification:"
                               clas_name={i.classification}
                               
                               
                               alt="Alternate Drug Available?"
                               alt_name={i.alternateDrugAvailable}
                               url="URL:"
                               url_name={i.gl_url}
             
                      />  
      )  
      ) : null
}
  </Grid>

</>
);
}